<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('partnersWithdrawals.WithdrawalOfPartners')"
          :description="$t('partnersWithdrawals.FromHereYouCanControlPartnerWithdrawals')"
        />
        <indexTable
          :searchText="$t('partnersWithdrawals.SearchForAnOperation')"
          :emptyTableText="$t('partnersWithdrawals.thereAreNoWithdrawalsOperations')"
          :buttonRole="$user.role.purchase_payments_add"
          :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('partnersWithdrawals.Process'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'partner_id',
              title: $t('partnersWithdrawals.PartnerName'),
              type: 'link',
              to: 'partner',
              sort: true,
              link: true
            },
            {
              column: 'safe_id',
              title: $t('partnersWithdrawals.Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            { column: 'date', title: $t('partnersWithdrawals.date'), type: 'text', sort: true },
            {
              column: 'description',
              title: $t('partnersWithdrawals.AndThatIsAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('partnersWithdrawals.cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('partnersWithdrawals.actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $user.admin || $user.role.purchase_payments_edit
                },
                { name: 'file' },
                { name: 'printPurchasePayment', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $user.admin || $user.role.purchase_payments_delete
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/partnersWithdrawals'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
